import { useState } from 'react'
import RulesPanel from './RulesPanel'
import BulkAssignPanel from './BulkAssignPanel'
import RunsPanel from './RunsPanel'

// Automatic membership by email, for Super Admins: rules, placing the people who are already here,
// and the list of runs with undo.
export default function AutoAssignPanel({ opcos }) {
  const [runsVersion, setRunsVersion] = useState(0)
  return (
    <div className="space-y-6">
      <RulesPanel opcos={opcos} />
      <BulkAssignPanel onApplied={() => setRunsVersion((v) => v + 1)} />
      <RunsPanel reloadKey={runsVersion} />
    </div>
  )
}
